import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <span className="footer-text">Model Agency Cape Town South Africa</span>
        <span className="footer-divider">|</span>
        <a href="mailto:info@dmanagement.co.za">info@dmanagement.co.za</a>
        <span className="footer-divider">|</span>
        <a href="https://www.instagram.com/dmanagement/" target="_blank" rel="noopener noreferrer">Instagram</a>
      </div>
    </footer>
  );
}
